var $eb82ef981b5592bf$exports = {};
$eb82ef981b5592bf$exports = {
  "calendar": "Calendar",
  "day": "zi",
  "dayPeriod": "a.m/p.m.",
  "endDate": "Dat\u0103 final",
  "era": "er\u0103",
  "hour": "or\u0103",
  "minute": "minut",
  "month": "lun\u0103",
  "second": "secund\u0103",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Dat\u0103 selectat\u0103: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Interval selectat: de la ".concat(args.startDate, " p\xE2n\u0103 la ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Ora selectat\u0103: ".concat(args.time);
  },
  "startDate": "Dat\u0103 \xEEnceput",
  "timeZoneName": "fus orar",
  "weekday": "ziua din s\u0103pt\u0103m\xE2n\u0103",
  "year": "an"
};
export { $eb82ef981b5592bf$exports as default };